// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"686":"1ed7e927","746":"2100dece","858":"93e9dd3f"}[chunkId] + ".chunk.js";
};